export default __webpack_public_path__ + "assets/user-component.d406ef35.svg";